const EMPTY_CHART_TEXT = 'Нет данных для отображения';

const toNumber = value => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

const normalizeLabel = (value, index) => {
  const label = String(value ?? '').trim();
  return label || `Район ${index + 1}`;
};

const makeDistrictKey = (ids = [], labels = [], index) => {
  const id = ids[index];
  if (id !== undefined && id !== null && String(id).trim()) {
    return `id:${String(id).trim()}`;
  }

  return `index:${index}:${normalizeLabel(labels[index], index)}`;
};

const hasPositiveValues = (series = [], totals = []) => (
  totals.some(item => toNumber(item) > 0)
  || series.some(item => (item.data || []).some(value => toNumber(value) > 0))
);

export const normalizeStatisticsChartData = (chart = {}) => {
  const rawLabels = Array.isArray(chart.categories) ? chart.categories : [];
  const rawIds = Array.isArray(chart.category_ids) ? chart.category_ids : [];
  const rawSeries = Array.isArray(chart.series) ? chart.series : [];
  const rawTotals = Array.isArray(chart.totals) ? chart.totals : [];
  const districts = [];
  const districtIndexByKey = new Map();
  const sourceIndexToDistrictIndex = [];

  rawLabels.forEach((label, index) => {
    const key = makeDistrictKey(rawIds, rawLabels, index);
    let districtIndex = districtIndexByKey.get(key);

    if (districtIndex === undefined) {
      districtIndex = districts.length;
      districtIndexByKey.set(key, districtIndex);
      districts.push({
        id: rawIds[index] || null,
        name: normalizeLabel(label, index),
      });
    }

    sourceIndexToDistrictIndex[index] = districtIndex;
  });

  const totals = new Array(districts.length).fill(0);
  rawTotals.forEach((total, index) => {
    const districtIndex = sourceIndexToDistrictIndex[index];
    if (districtIndex !== undefined) {
      totals[districtIndex] += toNumber(total);
    }
  });

  const series = rawSeries.map((item, seriesIndex) => {
    const data = new Array(districts.length).fill(0);
    const sourceData = Array.isArray(item.data) ? item.data : [];

    sourceData.forEach((value, index) => {
      const districtIndex = sourceIndexToDistrictIndex[index];
      if (districtIndex !== undefined) {
        data[districtIndex] += toNumber(value);
      }
    });

    return {
      provider_id: item.provider_id,
      provider_name: item.provider_name,
      name: item.name || item.provider_name || item.provider_id || `Провайдер ${seriesIndex + 1}`,
      data,
    };
  });

  const effectiveTotals = totals.some(item => item > 0)
    ? totals
    : districts.map((_, districtIndex) => series.reduce((sum, item) => sum + toNumber(item.data[districtIndex]), 0));

  const hasValues = districts.length > 0
    && series.length > 0
    && hasPositiveValues(series, effectiveTotals);

  if (!hasValues) {
    return {
      series: [],
      labels: [],
      totals: [],
      barLabels: [],
      districts,
      isEmpty: true,
      emptyText: EMPTY_CHART_TEXT,
    };
  }

  return {
    series,
    labels: districts.map(item => item.name),
    totals: effectiveTotals,
    barLabels: series.map(item => item.provider_name || item.name),
    districts,
    isEmpty: false,
    emptyText: EMPTY_CHART_TEXT,
  };
};

export const createStatisticsTooltip = (labels = [], totals = []) => ({
  series, seriesIndex, dataPointIndex, w,
}) => {
  const escapeHtml = value => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const provider = w?.config?.series?.[seriesIndex]?.name || '-';
  const zone = labels[dataPointIndex] || '-';
  const value = series?.[seriesIndex]?.[dataPointIndex] || 0;
  const total = totals?.[dataPointIndex] || 0;

  return `
    <div class="statistics-tooltip">
      <div class="statistics-tooltip-title">${escapeHtml(zone)}</div>
      <div class="statistics-tooltip-row"><span>Провайдер</span><strong>${escapeHtml(provider)}</strong></div>
      <div class="statistics-tooltip-row"><span>Значение</span><strong>${escapeHtml(value)}</strong></div>
      <div class="statistics-tooltip-row"><span>Итого</span><strong>${escapeHtml(total)}</strong></div>
    </div>
  `;
};

export { EMPTY_CHART_TEXT };
